export interface SriLankaLocationData {
  province: string;
  districts: {
    name: string;
    cities: string[];
  }[];
}

export const SRI_LANKA_LOCATIONS: SriLankaLocationData[] = [
  {
    province: 'Western',
    districts: [
      {
        name: 'Colombo',
        cities: [
          'Colombo 01 - Fort',
          'Colombo 02 - Slave Island',
          'Colombo 03 - Colpetty',
          'Colombo 04 - Bambalapitiya',
          'Colombo 05 - Havelock Town',
          'Colombo 06 - Wellawatte',
          'Colombo 07 - Cinnamon Gardens',
          'Colombo 08 - Borella',
          'Colombo 09 - Dematagoda',
          'Colombo 10 - Maradana',
          'Colombo 11 - Pettah',
          'Colombo 12 - Hultsdorf',
          'Colombo 13 - Kotahena',
          'Colombo 14 - Grandpass',
          'Colombo 15 - Mutwal',
          'Nugegoda',
          'Maharagama',
          'Kottawa',
          'Piliyandala',
          'Dehiwala',
          'Mount Lavinia',
          'Moratuwa',
          'Battaramulla',
          'Malabe',
          'Kaduwela',
          'Hanwella',
          'Avissawella',
          'Homagama',
        ],
      },
      {
        name: 'Gampaha',
        cities: [
          'Gampaha',
          'Kadawatha',
          'Kelaniya',
          'Kiribathgoda',
          'Negombo',
          'Ja-Ela',
          'Wattala',
          'Ragama',
          'Minuwangoda',
          'Veyangoda',
          'Mirigama',
        ],
      },
      {
        name: 'Kalutara',
        cities: [
          'Kalutara',
          'Panadura',
          'Horana',
          'Bandaragama',
          'Matugama',
          'Aluthgama',
        ],
      },
    ],
  },
  {
    province: 'Central',
    districts: [
      {
        name: 'Kandy',
        cities: [
          'Kandy',
          'Peradeniya',
          'Katugastota',
          'Gampola',
          'Kundasale',
          'Wattegama',
        ],
      },
      {
        name: 'Matale',
        cities: ['Matale', 'Dambulla', 'Sigiriya'],
      },
      {
        name: 'Nuwara Eliya',
        cities: ['Nuwara Eliya', 'Hatton', 'Ginigathena'],
      },
    ],
  },
  {
    province: 'Southern',
    districts: [
      {
        name: 'Galle',
        cities: ['Galle', 'Hikkaduwa', 'Karapitiya', 'Ambalangoda', 'Elpitiya'],
      },
      {
        name: 'Matara',
        cities: ['Matara', 'Weligama', 'Akuressa', 'Kamburupitiya'],
      },
      {
        name: 'Hambantota',
        cities: ['Hambantota', 'Tangalle', 'Beliatta'],
      },
    ],
  },
  {
    province: 'Northern',
    districts: [
      {
        name: 'Jaffna',
        cities: ['Jaffna', 'Chavakachcheri', 'Point Pedro'],
      },
      {
        name: 'Mannar',
        cities: ['Mannar'],
      },
      {
        name: 'Vavuniya',
        cities: ['Vavuniya'],
      },
      {
        name: 'Mullaitivu',
        cities: ['Mullaitivu'],
      },
      {
        name: 'Kilinochchi',
        cities: ['Kilinochchi'],
      },
    ],
  },
  {
    province: 'Eastern',
    districts: [
      {
        name: 'Batticaloa',
        cities: ['Batticaloa', 'Kalkudah'],
      },
      {
        name: 'Ampara',
        cities: ['Ampara', 'Kalmunai'],
      },
      {
        name: 'Trincomalee',
        cities: ['Trincomalee'],
      },
    ],
  },
  {
    province: 'North Western',
    districts: [
      {
        name: 'Kurunegala',
        cities: ['Kurunegala', 'Kuliyapitiya', 'Wariyapola', 'Ibbagamuwa'],
      },
      {
        name: 'Puttalam',
        cities: ['Puttalam', 'Chilaw', 'Marawila'],
      },
    ],
  },
  {
    province: 'North Central',
    districts: [
      {
        name: 'Anuradhapura',
        cities: ['Anuradhapura', 'Eppawala'],
      },
      {
        name: 'Polonnaruwa',
        cities: ['Polonnaruwa'],
      },
    ],
  },
  {
    province: 'Uva',
    districts: [
      {
        name: 'Badulla',
        cities: ['Badulla', 'Bandarawela', 'Diyatalawa'],
      },
      {
        name: 'Moneragala',
        cities: ['Moneragala', 'Wellawaya'],
      },
    ],
  },
  {
    province: 'Sabaragamuwa',
    districts: [
      {
        name: 'Ratnapura',
        cities: ['Ratnapura', 'Balangoda', 'Embilipitiya'],
      },
      {
        name: 'Kegalle',
        cities: ['Kegalle', 'Mawanella'],
      },
    ],
  },
];

export const SRI_LANKAN_DISTRICTS = SRI_LANKA_LOCATIONS.flatMap((p) =>
  p.districts.map((d) => d.name),
);
export const SRI_LANKAN_SUBJECTS = [
  'Mathematics',
  'Science',
  'Combined Mathematics',
  'Physics',
  'Chemistry',
  'Biology',
  'ICT',
  'Accounting',
  'Business Studies',
  'Economics',
  'Sinhala',
  'Tamil',
  'English',
  'English Literature',
  'History',
  'Geography',
  'Religion',
  'Technology Streams',
];

export const SRI_LANKAN_GRADES = [
  'Primary (Grades 1-5)',
  'Middle School (Grades 6-9)',
  'O/L (Grades 10-11)',
  'A/L (Grades 12-13)',
  'Cambridge OL',
  'Cambridge AL',
  'Edexcel OL',
  'Edexcel AL',
  'IB Curriculum',
];

export const TARGET_AUDIENCE_OPTIONS = [
  'Preschool / Kindergarten',
  'Primary (Grade 1-5)',
  'Junior Secondary (Grade 6-9)',
  'Senior Secondary (G.C.E O/L)',
  'Senior Secondary (G.C.E A/L)',
  'Vocational Training Students',
  'University Students',
];

export const SUBJECT_OPTIONS_BY_AUDIENCE: Record<string, string[]> = {
  'Preschool / Kindergarten': [
    'English',
    'Tamil',
    'Mathematics',
    'Art & Craft',
    'Music',
    'Physical Education',
  ],
  'Primary (Grade 1-5)': [
    'Mathematics',
    'Science',
    'English',
    'Tamil',
    'Sinhala',
    'Social Studies',
    'Art & Craft',
    'Religion',
  ],
  'Junior Secondary (Grade 6-9)': [
    'Mathematics',
    'Science',
    'English',
    'Tamil',
    'Sinhala',
    'History',
    'Geography',
    'ICT',
    'Health & Physical Education',
    'Religion',
  ],
  'Senior Secondary (G.C.E O/L)': [
    'Mathematics',
    'Science',
    'English',
    'Sinhala',
    'Tamil',
    'History',
    'Geography',
    'ICT',
    'Business Studies',
    'Accounting',
    'Economics',
    'Art',
    'Music',
    'Drama',
    'Agriculture',
    'Engineering Technology',
  ],
  'Senior Secondary (G.C.E A/L)': [
    'Combined Mathematics',
    'Physics',
    'Chemistry',
    'Biology',
    'Accounting',
    'Business Studies',
    'Economics',
    'History',
    'Geography',
    'Political Science',
    'ICT',
    'Higher Mathematics',
    'Engineering Technology',
    'Bio Systems Technology',
  ],
  'Vocational Training Students': [
    'IT & Software',
    'Electrical & Electronics',
    'Mechanical Engineering',
    'Construction Technology',
    'Hospitality & Tourism',
    'Cosmetology',
    'Business Management',
  ],
  'University Students': [
    'Mathematics',
    'Statistics',
    'Physics',
    'Chemistry',
    'Computer Science',
    'Software Engineering',
    'Information Technology',
    'Engineering',
    'Business Administration',
    'Accounting & Finance',
    'Economics',
    'Law',
    'Medicine',
    'Psychology',
    'Education',
  ],
};
